'use strict'


$(function() { 

    if ($('.js-lg-save').length) {
        $('body').on('click', '.js-lg-save', function(e) {
            var $checked = $('input.js-lg-select:checked');
            var lg = '';
            var url = '';
            
            if ($checked.length) {
                lg = $checked.val();
                
                if ($checked.attr('data-active') == 'true') {
                    $('#js-modal-close').trigger('click');
                    setCookie('saved_lang', lg, 300);
                }
                else {
                    url = $('[data-name="js-lg-' + lg + '"]').text();
                    
                    setCookie('saved_lang', lg, 300);
                    document.location = url;
                }
            }
        });
    }

});